import { cloneElement } from 'react';
import { Box } from '@mui/material';
import { Draggable } from 'react-beautiful-dnd';

const DisplayLanguageTab = props => {
  return (
    <Draggable
      draggableId={`${props.value}`}
      index={props.index}
      disableInteractiveElementBlocking
    >
      {draggableProvided => (
        <Box
          ref={draggableProvided.innerRef}
          {...draggableProvided.draggableProps}
        >
          {cloneElement(props.child, {
            ...props,
            ...draggableProvided.dragHandleProps,
            style: { cursor: 'pointer' },
          })}
        </Box>
      )}
    </Draggable>
  );
};

export default DisplayLanguageTab;
